import React, { useEffect, useRef, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import TaxDisputeReceipt from "../../components/taxDispute/PDF/TaxDisputeReceipt";
import MainContent from "../../layouts/maincontent/MainContent";
import * as htmlToImage from "html-to-image";
import { jsPDF } from "jspdf";
import styles from "../taxDispute/listData/ListDisputeData.module.css";
import { getTaxDisputeReceipt } from "../../adapters/apis/lookups/lookups";
import { get } from "../../adapters/xhr/api";

function TaxDisputePdfReceipt() {
  const { id } = useParams();
  const printElectronic = useRef();
  const printRealEstateTax = useRef();
  const electronicPDF = printElectronic.current;
  const realEstateTaxPDF = printRealEstateTax.current;
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    checkVerfication();
  }, []);

  const checkVerfication = async () => {
    try {
      const response = await get("api/user/verifications", {}, true);
      const isFullyVerified = response?.data?.fully_verified;
      if (!isFullyVerified) {
        navigate("/DisabledHome");
      }
    } catch (error) {
      console.log(error);
    }
  };
  //with htmlToImage
  useEffect(() => {
    getTaxDisputeReceipt(id)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 404) {
          navigate("/not-found");
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleDownloadPdf = async () => {
    await htmlToImage
      .toPng(electronicPDF, { quality: 0.95 })

      .then(function (dataUrl) {
        const pdf = new jsPDF();

        const imgProperties = pdf.getImageProperties(dataUrl);

        const pdfWidth = pdf.internal.pageSize.getWidth();

        const pdfHeight =
          (imgProperties.height * pdfWidth) / imgProperties.width;

        pdf.addImage(dataUrl, "PNG", 0, 0, pdfWidth, pdfHeight);

        pdf.save(`إيصال المنازعات الضريبية.pdf`);
      });
  };
  return (
    <MainContent>
      <section
        className={`${styles.listData} ${styles["list-payment"]} list-payment`}
      >
        <div className="container pt-4">
          <div className={`${styles.box} p-lg-5 `}>
            <div className={`${styles["box-header"]}`}>
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-center w-100">
                {/* Left-Aligned Text */}
                <h3
                  className={`${styles["box-title"]} mb-md-5 mb-lg-0 ms-3 text-center text-md-start`}
                >
                  طباعة حالة الطلب
                </h3>

                {/* Right-Aligned Button */}
                <div className={`${styles["btns-header"]} mt-3 mt-md-0`}>
                  <button
                    type="button"
                    onClick={handleDownloadPdf}
                    className={styles["btns-header-order"]}
                  >
                    تحميل PDF
                  </button>
                </div>
              </div>
            </div>

            <div className={`${styles["box-body"]} mt-5`}>
              <div className={`${styles["box-body-content"]} pt-0`}>
                <div ref={printElectronic} className="p-lg-3 ">
                  <h3
                    className="p-4 fw-bold"
                    style={{ textAlign: "center", color: "#005DA8" }}
                  >
                    استعراض حالة الطلب
                  </h3>
                  <TaxDisputeReceipt data={data} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MainContent>
  );
}

export default TaxDisputePdfReceipt;
